import moment from "moment";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import {
  cancelPendingConciliation,
  markTransactionAsPending,
  ignoreTransaction,
} from "../../../../repositories/qerpapi/erp/financeiro/ConciliacaoBancariaRepository";
import { useContext, useCallback } from "react";
import { ConciliacaoBancariaContext } from "../contexts/ConciliacaoBancariaContext";
import { confirmConciliations } from "./../../../../repositories/qerpapi/erp/financeiro/ConciliacaoBancariaRepository";
import { notify } from "./../../../../utils/notify";
import { useHistory } from "react-router-dom";
import {
  findContasReceber,
  createContaReceber,
} from "./../../../../repositories/qerpapi/erp/financeiro/ContasReceberRepository";
import {
  findContasPagar,
  createContaPagar,
} from "./../../../../repositories/qerpapi/erp/financeiro/ContasPagarRepository";
import {
  findMovimentacaoConta,
  createMovimentacaoConta,
} from "./../../../../repositories/qerpapi/erp/financeiro/MovimentacaoContasRepository";
import { GlobalVariables } from "../../../../GlobalVariables";
import MaskService from "../../../../utils/mask/maskService";
import { validNotNull } from "../../../../utils/validations";
import {
  formatDateGetCurrentMonth,
  formatDateGetTime,
} from "../../../../utils/formatDate";
import { findUsuarios } from "../../../../repositories/qerpapi/erp/acesso/v1/UsuarioRepository";

const useConciliacaoBancariaController = () => {
  const { push } = useHistory();
  const {
    setLoading,
    fileId,
    setSearchPayments,
    setItensTotalPayments,
    setSearchReceipts,
    setItensTotalReceipts,
    setSearchMovimentations,
    setItensTotalMovimentations,
    bankAccount,
    setErrors,
    setMainClient,
    setMainSupplier,
  } = useContext(ConciliacaoBancariaContext);
  const { queryParams } = useContext(QueryParamsContext);

  const bankExtractFilterList = [
    { label: "Todos", value: "" },
    { label: "Valores Recebidos", value: "vr" },
    { label: "Valores Pagos", value: "vp" },
  ];

  const statusesList = [
    { label: "Todos", value: "" },
    { label: "Pendentes", value: "pendente" },
    { label: "Não Confirmados", value: "naoconfirmado" },
    { label: "Não Conciliados", value: "naoconciliado" },
    { label: "Ignorados", value: "ignorado" },
    { label: "Conciliados", value: "conciliado" },
  ];

  const erpList = [
    { label: "Todos", value: "" },
    { label: "Contas a pagar", value: "cp" },
    { label: "Contas a receber", value: "cr" },
    { label: "Movimentação bancária", value: "mb" },
  ];

  const categoriesList = [
    { label: "Todos", value: "" },
    { label: "Categorizados", value: "1" },
    { label: "Sem Categoria", value: "0" },
  ];

  const handleChangeSelect = (event, setState = () => {}, list = []) => {
    if (!event?.value) setState({ label: "Todos", value: "" });
    else setState(list.find((e) => e.value === event.value));
  };

  const executeScroll = (ref) =>
    ref?.current?.scrollIntoView({
      behavior: "smooth",
      block: "end",
    });

  const handleSelectedSupplier = (setModalSupplier, selectedSupplier) => {
    if (Array.isArray(selectedSupplier)) {
      setMainSupplier(selectedSupplier[0]);
    }
    setModalSupplier(false);
  };

  const handleSelectedClient = (setModalClient, selectedClient) => {
    if (Array.isArray(selectedClient)) {
      setMainClient(selectedClient[0]);
    }
    setModalClient(false);
  };

  const makeTransactionsArray = useCallback((rows = {}) => {
    let suggestionsArray = [];
    return Object.keys(rows).map((key) => {
      // if (rows[key].dataTransaction.type === "DEBIT")
      //   suggestionsArray = [
      //     ...Object.keys(rows[key].suggestions.payBills).map(
      //       (el) => rows[key].suggestions.payBills[el]
      //     ),
      //   ];
      // else
      //   suggestionsArray = [
      //     ...Object.keys(rows[key].suggestions.receiveBills).map(
      //       (el) => rows[key].suggestions.receiveBills[el]
      //     ),
      //   ];
      suggestionsArray = [
        ...(rows[key].suggestions ? rows[key].suggestions : []),
      ];

      suggestionsArray.forEach((item) => {
        let categoryArraySuggestion = [];
        if (item.category) {
          categoryArraySuggestion = [
            ...(item.category || []).map((item) => ({
              ...item.centerCust,
              idcentronegocio: item.centerBusiness?.id,
              rateio: item.percentage || 0.0,
            })),
          ];
        }
        item.category = categoryArraySuggestion;
        item.typeBillID = `${item.typeBill}_${item.id}`;
      });

      let pending = [];
      if (rows[key].match) {
        pending = [rows[key].match];
      }

      if (rows[key].conciliedTitle) {
        pending = rows[key].conciliedTitle;
      }

      if (rows[key].pending) {
        pending = Array.isArray(rows[key].pending)
          ? [...rows[key].pending]
          : [rows[key].pending];
      }
      pending.forEach((item) => {
        let categoryArray = [];
        if (item.category) {
          categoryArray = [
            ...(item.category || []).map((item) => ({
              ...item.centerCust,
              idcentronegocio: item.centerBusiness?.id,
              rateio: item.percentage || 0.0,
            })),
          ];
        }
        item.category = categoryArray;
        item.typeBillID = `${item.typeBill}_${item.id}`;
      });

      const obj = {
        status: "naoconciliado",
        ...rows[key],
        ...rows[key].dataTransaction,
        ...(rows[key].match && {
          status: "naoconfirmado",
        }),
        ...(rows[key].pending && {
          status: "pendente",
        }),
        ...(rows[key]?.dataTransaction?.ignored && {
          status: "ignorado",
        }),
        ...(rows[key]?.dataTransaction?.conciliated && {
          status: "conciliado",
        }),
        pending,
        suggestions: suggestionsArray,
      };

      delete obj.match;
      delete obj.dataTransaction;
      delete obj.conciliedTitle;
      return obj;
    });
  }, []);

  const filterTransactions = (
    rows,
    { extract, status, movimentations, category }
  ) =>
    rows.filter((transaction) => {
      let retorno = true;

      if (extract?.value) {
        if (extract?.value === "vp") retorno = transaction.amount < 0;
        else retorno = transaction.amount > 0;
      }

      if (status?.value) retorno = transaction.status === status?.value;

      if (category?.value) {
        if (category?.value === "1") {
          retorno = !!transaction.pending?.filter(
            (title) => !!title.category.length
          ).length;
        } else
          retorno = !transaction.pending?.filter(
            (title) => !!title.category.length
          ).length;
      }

      return retorno;
    });

  const makeConciliation = async (body) => {
    try {
      setLoading(true);
      const sendBody = {
        empresa_cnpj: queryParams.empresa_cnpj,
        empresa_id: queryParams.empresa_id,
        usuario_id: queryParams.usuario_id,
        arquivo_ofx_id: fileId,
        extrato_transacao_id: body.extrato_transacao_id,
        titulos: body.movimentacao_contas.map((e) => ({
          id: e.id,
          tipo: e.typeBill || null,
          numerodocto: e.numerodocto,
          valor: parseFloat(
            parseFloat(e.valor || e.value || e.valordocto || 0.0) +
              parseFloat(e.creditValue || 0.0)
          ).toFixed(2),
          multa: e.fine || 0.0,
          juros: e.fees || 0.0,
          abatimento: e.abatement || 0.0,
          gera_credito: e.gera_credito || "N",
          ...(e.category
            ? {
                centro_custo: e.category.map((center) => ({
                  centro_custo_id: center.id,
                  porcentagem: center.rateio,
                  centro_negocio_id: center.idcentronegocio,
                })),
              }
            : {}),
        })),
      };

      var callback = await markTransactionAsPending({
        empresa_cnpj: queryParams.empresa_cnpj,
        body: sendBody,
      });

      if (callback.success) notify(callback.message, true, "success");
      else notify(callback.message, true);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }

    return callback;
  };

  const ignoreConciliation = async (body) => {
    try {
      setLoading(true);

      const sendBody = {
        empresa_cnpj: queryParams.empresa_cnpj,
        empresa_id: queryParams.empresa_id,
        usuario_id: queryParams.usuario_id,
        arquivo_ofx_id: fileId,
        extrato_transacao_id: body.extrato_transacao_id,
      };

      var callback = await ignoreTransaction({
        empresa_cnpj: queryParams.empresa_cnpj,
        body: sendBody,
      });

      if (callback.success) notify(callback.message, true, "warning");
      else notify(callback.message, true);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }

    return callback;
  };

  const cancelIgnoreConciliation = async (body) => {
    try {
      setLoading(true);

      var callback = await cancelPendingConciliation({
        empresa_cnpj: queryParams.empresa_cnpj,
        body: {
          empresa_cnpj: queryParams.empresa_cnpj,
          empresa_id: queryParams.empresa_id,
          usuario_id: queryParams.usuario_id,
          arquivo_ofx_id: fileId,
          extrato_transacao_id: body.extrato_transacao_id,
          titulos: [
            {
              tipo: "ignored",
            },
          ],
        },
      });

      notify("Ignorar removido da transação", true, "warning");
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }

    return callback;
  };

  const cancelTitleConciliation = async (body = {}, transacaoId = null) => {
    try {
      setLoading(true);

      var callback = await cancelPendingConciliation({
        empresa_cnpj: queryParams.empresa_cnpj,
        body: {
          empresa_cnpj: queryParams.empresa_cnpj,
          empresa_id: queryParams.empresa_id,
          usuario_id: queryParams.usuario_id,
          arquivo_ofx_id: fileId,
          extrato_transacao_id: transacaoId,
          titulos: [
            {
              id: body.id,
              tipo: "ignored" || null,
            },
          ],
        },
      });

      notify(callback.message, true, "warning");
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }

    return callback;
  };

  const cancelConciliation = async (body) => {
    try {
      setLoading(true);

      var callback = await cancelPendingConciliation({
        empresa_cnpj: queryParams.empresa_cnpj,
        body: {
          empresa_cnpj: queryParams.empresa_cnpj,
          empresa_id: queryParams.empresa_id,
          usuario_id: queryParams.usuario_id,
          arquivo_ofx_id: fileId,
          extrato_transacao_id: body.extrato_transacao_id,
          titulos: body.movimentacao_contas.map((e) => ({
            id: e.id,
            tipo: e.typeBill || null,
          })),
        },
      });

      notify(callback.message, true, "warning");
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }

    return callback;
  };

  const receivableDocSituation = [
    { value: GlobalVariables.RecieveSituations.inWallet, label: "Em Carteira" },
    { value: GlobalVariables.RecieveSituations.inCharge, label: "Em Cobrança" },
    {
      value: GlobalVariables.RecieveSituations.inNotaryOffice,
      label: "Em Cartorio",
    },
    {
      value: GlobalVariables.RecieveSituations.protest,
      label: "Protestado",
    },
    {
      value: GlobalVariables.RecieveSituations.partiallyLiquidated,
      label: "Liquidado Parcialmente",
    },
    {
      value: GlobalVariables.RecieveSituations.fullyLiquidated,
      label: "Liquidado Totalmente",
    },
    {
      value: GlobalVariables.RecieveSituations.factoring,
      label: "Desconto de Título - Factoring",
    },
    { value: GlobalVariables.RecieveSituations.loaded, label: "Baixado" },
    {
      value: GlobalVariables.RecieveSituations.dealing,
      label: "Depto Jurídico - Negociando",
    },
    { value: GlobalVariables.RecieveSituations.canceled, label: "Cancelado" },
    {
      value: GlobalVariables.RecieveSituations.renegotiated,
      label: "Renegociado",
    },
    {
      value: GlobalVariables.RecieveSituations.creditRecovery,
      label: "Recup. Crédito",
    },
    { value: GlobalVariables.RecieveSituations.suspended, label: "Suspenso" },
    {
      value: GlobalVariables.RecieveSituations.waitingLoaded,
      label: "Aguardando Baixa",
    },
    {
      value: GlobalVariables.RecieveSituations.returnToBank,
      label: "Devolvido Banco",
    },
  ];

  const payablesDocSituation = [
    { value: GlobalVariables.PaySituations.inWallet, label: "Em Carteira" },
    { value: GlobalVariables.PaySituations.inCharge, label: "Em Cobrança" },
    {
      value: GlobalVariables.PaySituations.inNotaryOffice,
      label: "Em Cartorio",
    },
    { value: GlobalVariables.PaySituations.protest, label: "Protestado" },
    {
      value: GlobalVariables.PaySituations.partiallyLiquidated,
      label: "Liquidado Parcialmente",
    },
    {
      value: GlobalVariables.PaySituations.fullyLiquidated,
      label: "Liquidado Totalmente",
    },
    {
      value: GlobalVariables.PaySituations.factoring,
      label: "Desconto de Título - Factoring",
    },
    { value: GlobalVariables.PaySituations.loaded, label: "Baixado" },
    {
      value: GlobalVariables.PaySituations.dealing,
      label: "Depto Jurídico - Negociando",
    },
    { value: GlobalVariables.PaySituations.canceled, label: "Cancelado" },
    { value: GlobalVariables.PaySituations.renegotiated, label: "Renegociado" },
  ];

  const confirmateConciliations = async () => {
    try {
      if (!bankAccount) {
        return notify(
          "Selecione uma conta bancária antes de continuar",
          true,
          "warning"
        );
      }
      setLoading(true);

      const callback = await confirmConciliations({
        empresa_cnpj: queryParams.empresa_cnpj,
        body: {
          empresa_cnpj: queryParams.empresa_cnpj,
          empresa_id: queryParams.empresa_id,
          usuario_id: queryParams.usuario_id,
          agencia_id: bankAccount.id,
          arquivo_ofx_id: fileId,
          gf_token: queryParams.gfAccessToken,
        },
      });

      if (!callback.success) return notify(callback.message);
      else {
        push(
          `conciliacaoupload?empresa_cnpj=${queryParams.empresa_cnpj}&empresa_id=${queryParams.empresa_id}&usuario_id=${queryParams.usuario_id}`
        );
        return notify("Conciliação confirmada com sucesso!", true, "success");
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const getReceiptsbills = useCallback(
    async (newPage = 1, search = false, filter = "") => {
      setLoading(true);

      try {
        let date = findAndReturnFormatedDate(filter);
        let monetaryValue = findAndReturnFormatedMonetaryValue(filter);
        let filteredId = findAndReturnFormatedId(filter);

        let whereDoesntHave = {
          conciliacaoBancariaAberta: {
            where: {
              titulo_type: GlobalVariables.classeConciliacao.contasReceber,
            },
          },
        };

        let filterOrWhere = filter.length
          ? {
              id: `${filteredId || null}`,
              historico: `${filter}`,
              valordocto: `${monetaryValue || null}`,
              datavencto: `${date || null}`,
              numerodocto: `${filter}`,
            }
          : {};

        let orWhere = { ...filterOrWhere };
        let orWhereHas = filter.length
          ? {
              "cliente.razao": `${filter}`,
            }
          : {};
        let wherein = {
          situacaodocto: [
            GlobalVariables.situacaoReceber.carteira,
            GlobalVariables.situacaoReceber.cobranca,
            GlobalVariables.situacaoReceber.cartorio,
            GlobalVariables.situacaoReceber.protestado,
            GlobalVariables.situacaoReceber.liquidadoParcialmente,
            GlobalVariables.situacaoReceber.negociando,
          ],
        };
        const callback = await findContasReceber({
          empresa_cnpj: queryParams.empresa_cnpj,
          wherein,
          orWhere,
          orWhereHas,
          whereDoesntHave,
          page: newPage,
          include: "cliente,centroCusto",
        });

        if (callback.success) {
          callback.data.map((obj) => {
            let categoryArray = [];
            if (obj.centro_custo) {
              categoryArray = [
                ...(obj.centro_custo || []).map((item) => ({
                  id: item.id,
                  codigo: item.codigo,
                  descricao: item.descricao,
                  idcentronegocio: item.pivot?.idcentronegocio,
                  rateio: item.pivot?.porcentagem || 0.0,
                })),
              ];
            }
            switch (obj.situacaodocto) {
              case GlobalVariables.situacaoReceber.liquidadoTotalmente:
                obj.valordocto =
                  obj.valordoctooriginal +
                  obj.nr_juros +
                  obj.nr_multa -
                  obj.nr_abatimento -
                  obj.nr_desconto;
                break;
              default:
                // obj.valordocto = obj.valordocto;
                break;
            }
            obj.situation = receivableDocSituation.find(
              (e) => e.value === obj.situacaodocto
            )?.label;
            obj.category = categoryArray;
            obj.typeBill = "accountsReceivable";
            obj.typeBillID = `accountsReceivable_${obj.id}`;
            return obj;
          });
        } else {
          notify(callback.message, true);
        }

        if (search) return callback.success ? callback : [];

        setSearchReceipts(callback.success ? callback.data : []);
        setItensTotalReceipts(callback.success ? callback.total : 0);
      } catch (e) {
        console.error(e);
        return false;
      } finally {
        setLoading(false);
      }
    },
    [setLoading, queryParams, setSearchReceipts, setItensTotalReceipts]
  );

  const getPaybills = useCallback(
    async (newPage = 1, search = false, filter = "") => {
      setLoading(true);

      try {
        let date = findAndReturnFormatedDate(filter);
        let monetaryValue = findAndReturnFormatedMonetaryValue(filter);
        let filteredId = findAndReturnFormatedId(filter);

        let filterOrWhere = filter.length
          ? {
              id: `${filteredId || null}`,
              historico: `${filter}`,
              valordocto: `${monetaryValue || null}`,
              datavencto: `${date || null}`,
              numerodocto: `${filter}`,
            }
          : {};

        let orWhere = { ...filterOrWhere };

        let orWhereHas = filter.length
          ? {
              "fornecedor.razao": `${filter}`,
              "cliente.razao": `${filter}`,
              "parceiroComercial.nome": `${filter}`,
              "vendedor.nomevendedor": `${filter}`,
              "funcionario.nome": `${filter}`,
            }
          : {};

        let wherein = {
          situacaodocto: [
            GlobalVariables.situacaoReceber.carteira,
            GlobalVariables.situacaoReceber.cobranca,
            GlobalVariables.situacaoReceber.cartorio,
            GlobalVariables.situacaoReceber.protestado,
            GlobalVariables.situacaoReceber.liquidadoParcialmente,
            GlobalVariables.situacaoReceber.negociando,
          ],
        };

        let whereDoesntHave = {
          conciliacaoBancariaAberta: {
            where: {
              titulo_type: GlobalVariables.classeConciliacao.contasPagar,
            },
          },
        };

        const callback = await findContasPagar({
          empresa_cnpj: queryParams.empresa_cnpj,
          wherein,
          whereDoesntHave,
          orWhere,
          orWhereHas,
          page: newPage,
          include:
            "cliente,fornecedor,funcionario,vendedor,parceiroComercial,centroCusto",
        });

        if (callback.success) {
          callback.data.map((obj) => {
            let categoryArray = [];
            if (obj.centro_custo) {
              categoryArray = [
                ...(obj.centro_custo || []).map((item) => ({
                  id: item.id,
                  codigo: item.codigo,
                  descricao: item.descricao,
                  idcentronegocio: item.pivot?.idcentronegocio,
                  rateio: item.pivot?.porcentagem || 0.0,
                })),
              ];
            }
            switch (obj.situacaodocto) {
              case GlobalVariables.situacaoReceber.liquidadoTotalmente:
                obj.valordocto =
                  obj.valordoctooriginal +
                  obj.nr_juros +
                  obj.nr_multa -
                  obj.valorabatimentodocto -
                  obj.nr_desconto;
                break;
              default:
                // obj.valordocto = obj.valordocto;
                break;
            }

            obj.category = categoryArray;
            obj.typeBill = "accountsPay";
            obj.typeBillID = `accountsPay_${obj.id}`;
            obj.situation = payablesDocSituation.find(
              (e) => e.value === obj.situacaodocto
            )?.label;
            return obj;
          });
        } else {
          notify(callback.message, true);
        }

        if (search) return callback.success ? callback : [];

        setSearchPayments(callback.success ? callback.data : []);
        setItensTotalPayments(callback.success ? callback.total : 0);
      } catch (e) {
        console.error(e);
        return false;
      } finally {
        setLoading(false);
      }
    },
    [queryParams, setSearchPayments, setItensTotalPayments, setLoading]
  );

  const getMovimentations = useCallback(
    async ({
      type,
      newPage = 1,
      search = false,
      filter = "",
      whereNull = [],
    }) => {
      setLoading(true);

      try {
        let date = findAndReturnFormatedDate(filter);
        let monetaryValue = findAndReturnFormatedMonetaryValue(filter);
        let filteredId = findAndReturnFormatedId(filter);

        let filterOrWhere = filter.length
          ? {
              id: `${filteredId || null}`,
              historico: `${filter}`,
              valor: `${monetaryValue || null}`,
              data: `${date || null}`,
            }
          : {};

        let orWhere = { ...filterOrWhere };

        let where = {
          tipo: type,
        };

        const callback = await findMovimentacaoConta({
          empresa_cnpj: queryParams.empresa_cnpj,
          where,
          orWhere,
          page: newPage,
          include:
            "centroCusto,recebimentos.contasReceber.centroCusto,pagamentos.contasPagar.centroCusto",
          whereNull,
        });

        if (callback.success) {
          callback.data.map((obj) => {
            let categoryArray = [];
            if (obj.centro_custo) {
              categoryArray = [
                ...(obj.centro_custo || []).map((item) => ({
                  id: item.id,
                  codigo: item.codigo,
                  descricao: item.descricao,
                  idcentronegocio: item.pivot?.idcentronegocio,
                  rateio: item.pivot?.porcentagem || 0.0,
                })),
              ];
              
              if (obj.recebimentos[0]?.contas_receber[0]?.centro_custo) {
                categoryArray = [
                  ...(
                    obj.recebimentos[0]?.contas_receber[0]?.centro_custo || []
                  ).map((item) => ({
                    id: item.id,
                    codigo: item.codigo,
                    descricao: item.descricao,
                    idcentronegocio: item.pivot?.idcentronegocio,
                    rateio: item.pivot?.porcentagem || 0.0,
                  })),
                ];
              }
              if (obj.pagamentos[0]?.contas_pagar[0]?.centro_custo) {
                categoryArray = [
                  ...(
                    obj.pagamentos[0]?.contas_pagar[0]?.centro_custo || []
                  ).map((item) => ({
                    id: item.id,
                    codigo: item.codigo,
                    descricao: item.descricao,
                    idcentronegocio: item.pivot?.idcentronegocio,
                    rateio: item.pivot?.porcentagem || 0.0,
                  })),
                ];
              }
            }
            obj.category = categoryArray;
            obj.typeBill = "movimentationsBank";
            obj.typeBillID = `movimentationsBank_${obj.id}`;
            return obj;
          });
        } else {
          notify(callback.message, true);
        }

        if (search) return callback.success ? callback : [];

        setSearchMovimentations(callback.success ? callback.data : []);
        setItensTotalMovimentations(callback.success ? callback.total : 0);
      } catch (e) {
        console.error(e);
        return false;
      } finally {
        setLoading(false);
      }
    },
    [
      queryParams,
      setSearchMovimentations,
      setItensTotalMovimentations,
      setLoading,
    ]
  );

  const createAccountMovimentation = async (fields = {}) => {
    try {
      setLoading(true);

      const resultValidation = validNotNull([
        { value: fields.bankAgency, key: "bankAgency" },
        { value: fields.tipo, key: "tipo" },
        { value: fields.data, key: "data" },
        { value: fields.valor, key: "valor" },
      ]);

      if (MaskService.removeMaskDecimal(fields.valor) === 0) {
        resultValidation.errorsValidation.valor = "Campo obrigatório";
        resultValidation.error = true;
      }

      if (fields.checkTransfer && !fields.transferBankAgency) {
        resultValidation.errorsValidation.transferBankAgency =
          "Campo obrigatório";
        resultValidation.error = true;
      }

      if (resultValidation.error) {
        setErrors(resultValidation.errorsValidation);
        notify("Verifique se os campos obrigatórios estão preenchidos.");
        return { success: false };
      }

      const addCentroCusto = fields.itemCategory?.length
        ? {
            centroCusto: fields.itemCategory.map((e) => ({
              idcentrocusto: e.id || null,
              idcentronegocio: e.idcentronegocio || null,
              porcentagem: e.rateio || null,
            })),
          }
        : {};

      const sendBody = {
        idempresa: queryParams.empresa_id,
        data: fields.data,
        idagencia: fields.bankAgency?.id,
        tipo: fields.tipo === "CREDIT" ? "C" : "D",
        transferencia: fields.checkTransfer ? "S" : "N",
        idagenciaorigemdestino: fields.transferBankAgency?.id,
        valor: fields.valor ?? "",
        historico: fields.historico,
        origem: "conciliacao",
        ...addCentroCusto,
      };

      const callback = await createMovimentacaoConta({
        empresa_cnpj: queryParams.empresa_cnpj,

        body: {
          empresa_cnpj: queryParams.empresa_cnpj,
          usuario_id: queryParams.usuario_id,
          movimentacaoConta: sendBody,
        },
      });

      if (!callback.success) {
        notify(callback.message);
        return { success: false };
      }

      notify(callback.message, true, "success");
      return callback;
    } catch (error) {
      notify("Não foi possível criar a movimentação.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const createBillsToReceiveOrPayments = async (fields = {}, addPayments) => {
    try {
      setLoading(true);

      const resultValidation = validNotNull([
        { value: fields.receiver, key: "receiver" },
        { value: fields.dataEmissao, key: "dataEmissao" },
        { value: fields.dataVencimento, key: "dataVencimento" },
        { value: fields.numeroDoc, key: "numeroDoc" },
        { value: fields.valorDoc, key: "valorDoc" },
        { value: fields.realizadoPrevisto, key: "realizadoPrevisto" },
      ]);

      if (MaskService.removeMaskDecimal(fields.valorDoc) === 0) {
        resultValidation.errorsValidation.valorDoc = "Campo obrigatório";
        resultValidation.error = true;
      }

      if (resultValidation.error) {
        setErrors(resultValidation.errorsValidation);
        notify("Verifique se os campos obrigatórios estão preenchidos.");
        return { success: false };
      }

      const idReciver = addPayments
        ? { idfornecedor: fields.receiver?.id || null }
        : { idcliente: fields.receiver?.id || null };

      const fieldAgencia = addPayments
        ? { idagencias: bankAccount.id }
        : { idagencia: bankAccount.id };

      const fieldAltorizado = addPayments ? { autorizado: "N" } : {};

      const mesCompetencia = formatDateGetCurrentMonth({
        date: fields.dataEmissao,
        separator: "/",
        format: "mm/yyyy",
      });

      const fieldMesCompetencia = addPayments
        ? {}
        : { mes_competencia: mesCompetencia };

      const todayDate = formatDateGetTime({
        date: new Date(Date.now()),
        separator: "-",
        format: "yyyy-mm-dd-hh:mm:ss",
      });

      const callBackUsuario = await findUsuarios(
        queryParams.empresa_cnpj,
        queryParams.usuario_id
      );

      const usuarioLogado = callBackUsuario.success
        ? callBackUsuario.data.login
        : null;

      const addCentroCusto = fields.itemCategory?.length
        ? {
            centroCusto: fields.itemCategory.map((e) => ({
              idcentrocusto: e.id || null,
              idcentronegocio: e.idcentronegocio || null,
              porcentagem: e.rateio || null,
            })),
          }
        : {};

      const sendBody = {
        idempresa: queryParams.empresa_id,
        ...idReciver,
        dataemissao: fields.dataEmissao || null,
        datavencto: fields.dataVencimento || null,
        numerodocto: fields.numeroDoc || "",
        valordocto: fields.valorDoc || "",
        previstorealizado: fields.realizadoPrevisto?.value || null,
        historico: fields.historico,
        datavenctooriginal: fields.dataVencimento || null,
        valordoctooriginal: fields.valorDoc || "",
        situacaodocto: "00",
        datahoralancou: todayDate,
        quemlancou: usuarioLogado,
        mes_competencia: moment().format("MM/YYYY"),
        origem: "conciliacao",
        ...fieldAgencia,
        ...fieldAltorizado,
        ...fieldMesCompetencia,
        ...addCentroCusto,
      };

      let callback;

      if (addPayments) {
        callback = await createContaPagar({
          empresa_cnpj: queryParams.empresa_cnpj,
          body: {
            usuario_id: queryParams.usuario_id,
            contapagar: sendBody,
          },
        });
      } else {
        callback = await createContaReceber({
          empresa_cnpj: queryParams.empresa_cnpj,
          body: {
            usuario_id: queryParams.usuario_id,
            contareceber: sendBody,
          },
        });
      }

      if (!callback.success) {
        notify(callback.message);
        return { success: false };
      }

      if (callback.data) {
        callback.data.participant = fields.receiver?.razao;
      }

      notify(callback.message, true, "success");
      return callback;
    } catch (error) {
      notify("Não foi possível criar a movimentação.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const findAndReturnFormatedDate = (text) => {
    // Retorna a primeira ocorrência de uma data
    // e retorna ela formatada no padrão americano
    let filteredDate = text.match(/\d{2}(\/)\d{2}\1\d{4}/);
    let date = "";
    if (filteredDate) {
      let arrayDate = filteredDate[0].split("/");
      date = `${arrayDate[2]}-${arrayDate[1]}-${arrayDate[0]}`;
    }
    return date;
  };

  const findAndReturnFormatedMonetaryValue = (text) => {
    // Retorna a primeira ocorrência de um valor monetário
    // e retorna ela formatada sem pontos e com um ponto no lugar da vírgula
    let filteredMonetaryValue = text.match(/[0-9.]*,\d{2}/);
    let removeMaskMonetaryValue = "";
    if (filteredMonetaryValue) {
      removeMaskMonetaryValue = filteredMonetaryValue[0]
        .replaceAll(".", "")
        .replace(",", ".");
    }
    return removeMaskMonetaryValue;
  };

  const findAndReturnFormatedId = (text) => {
    // Retorna apenas a primeira ocorrência de valor numérico que não contenha
    // letras ou caracteres especiais
    let filteredId = text.replace(/[`~!@#$%^&*()+=[{\]}|'<,.>?\\/"\-;:]/g, "w");
    filteredId = filteredId.match(/\b(\d+)\b/);
    let id = "";
    if (filteredId) {
      id = filteredId[0];
    }
    return id;
  };

  const handleSelectClient = (selectedClient) => {
    if (selectedClient) {
      setMainClient(selectedClient);
    } else {
      setMainClient(null);
    }
  };

  const handleSelectSupplier = (selectedSupplier) => {
    if (selectedSupplier) {
      setMainSupplier(selectedSupplier);
    } else {
      setMainSupplier(null);
    }
  };

  const clientGetOptionLabel = (option) => {
    return `${option.razao} ${
      option.cpfcnpj
        ? `(${MaskService.toMask(
            option.cpfcnpj.replace(/[^0-9]+/g, "").length === 11
              ? "cpf"
              : "cnpj",
            option.cpfcnpj
          )})`
        : ""
    }`;
  };

  const supplierGetOptionLabel = (option) => {
    return `${option.razao} ${
      option.cgc
        ? `(${MaskService.toMask(
            option.cgc.replace(/[^0-9]+/g, "").length === 11 ? "cpf" : "cnpj",
            option.cgc
          )})`
        : ""
    }`;
  };

  return {
    bankExtractFilterList,
    statusesList,
    erpList,
    categoriesList,

    handleChangeSelect,
    executeScroll,
    makeTransactionsArray,
    filterTransactions,

    makeConciliation,
    cancelConciliation,
    confirmateConciliations,
    ignoreConciliation,
    cancelIgnoreConciliation,
    cancelTitleConciliation,
    getReceiptsbills,
    getPaybills,
    getMovimentations,
    createAccountMovimentation,
    handleSelectClient,
    clientGetOptionLabel,
    handleSelectSupplier,
    handleSelectedSupplier,
    handleSelectedClient,
    supplierGetOptionLabel,
    createBillsToReceiveOrPayments,
  };
};

export default useConciliacaoBancariaController;
